module.exports = __webpack_public_path__ + "static/calefaccion-99387ab7671f270fd2672a46b94fafa0.jpg";